export async function noopAsync<T>() {
    const result = await new Promise((resolve) => resolve(null));
    return result as T;
}
